import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=d3d88088&scoped=true&"
import script from "./PromotionList.vue?vue&type=script&lang=js&"
export * from "./PromotionList.vue?vue&type=script&lang=js&"
import style0 from "./PromotionList.vue?vue&type=style&index=0&id=d3d88088&prod&lang=scss&scoped=true&"
import style1 from "./PromotionList.vue?vue&type=style&index=1&id=d3d88088&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d88088",
  null
  
)

export default component.exports